<template>
  <v-container :fluid="(fluid || isFluid)" :style="{'margin-bottom': bottom}">
    <v-row dense :justify="justify">
      <v-col :cols="_cols.cols" v-bind="$attrs">
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'z-container',
    props: {
      fluid: {
        type: Boolean,
        default: false
      },

      justify: {
        type: String,
        default: 'center'
      },

      xl: {
        type: [String, Number],
        default: 9
      },

      cols: {
        type: [String, Number],
        default: '10'
      },

      bottom: {
        type: [String, Number],
        default: '200px'
      }
    },

    computed: {
      columns() {
        return this.fluid ? 12 : this.xl; 
      },

      isFluid() {
        return this.fluid || this.$vuetify.breakpoint.lgAndDown;
      },

      isHD() {
        return this.$vuetify.breakpoint.width <= 1440;
      },

      _cols() {
        if (this.isHD) {
          return {
            cols: 12,
            fluid: true
          };
        }

        return {
          cols: this.cols,
          fluid: false
        };
      }
    },

  }
</script>

<style scoped>

</style>